import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";

import { authPuedeGestionFamiliar, getAuthValue } from "../../lib/authSession";
import { START_PATH } from "../../config/runtime";

export const PageLoader = ({ message = "Cargando..." }) => (
  <div className="container py-5 text-center">{message}</div>
);

export const renderLazy = (Component, props = {}, fallbackMessage = "Cargando...") => (
  <Suspense fallback={<PageLoader message={fallbackMessage} />}>
    <Component {...props} />
  </Suspense>
);

export const RutaProtegidaPaciente = ({ authLoading, children }) => {
  const isAuthenticated = !!getAuthValue("auth");
  const userRol = getAuthValue("userRol");
  const esPacienteOuResponsable = userRol === "paciente" || userRol === "responsable";
  if (authLoading) return <PageLoader message="Cargando tu sesión..." />;
  if (!isAuthenticated || !esPacienteOuResponsable) return <Navigate to={START_PATH} replace />;
  return children;
};

export const RutaProtegidaGestionFamiliar = ({ authLoading, children }) => {
  const isAuthenticated = !!getAuthValue("auth");
  const userRol = getAuthValue("userRol");
  const esPacienteOuResponsable = userRol === "paciente" || userRol === "responsable";
  if (authLoading) return <PageLoader message="Cargando tu sesión..." />;
  if (!isAuthenticated || !esPacienteOuResponsable) return <Navigate to={START_PATH} replace />;
  if (!authPuedeGestionFamiliar()) return <Navigate to={START_PATH} replace />;
  return children;
};
